import {Pipe, PipeTransform} from '@angular/core';
import NumberFormat = Intl.NumberFormat;

@Pipe({
  name: 'priceFormat'
})
export class PriceFormatPipe implements PipeTransform {

  transform(value: number, ...args: any[]): string {
    if (!isNaN(value)) {
      const numberFormat: NumberFormat = new NumberFormat('en', {
        style: 'decimal',
        minimumFractionDigits: 2,
      });
      return numberFormat.format(value);
    }
    return '';
  }
}
